import { useTranslation } from "react-i18next";
import type { JackpotCampaign } from "@/campaigns/modules/jackpot/types";
import { CampaignFinishedCard } from "@/components/campaign-card/campaign-finished-card";
import { CampaignJoinState } from "@/components/campaign-card/campaign-join-cta";
import { CampaignDockPanel } from "@/components/campaigns/campaign-shell/campaign-dock-panel";
import { FINISHED_DIM } from "@/components/campaigns/campaign-shell/campaign-view";
import { JackpotBoard } from "./jackpot-board";
import { JackpotLatestWinsCard } from "./jackpot-latest-wins-card";

/**
 * A jackpot campaign in the overlay's dock column: the detail view's sections
 * at dock density — the join state, every pot (the board owns the clock), then
 * the latest wins. Once it is over, the detail view's finished card leads and
 * the wins grey out as history.
 */
export const JackpotDockPanel = ({
  jackpotCampaign,
  joined,
}: {
  jackpotCampaign: JackpotCampaign;
  joined: boolean;
}) => {
  const { t } = useTranslation();
  const finished = jackpotCampaign.campaign.status === "FI";

  return (
    <CampaignDockPanel minimumBet={jackpotCampaign.minimum_bet}>
      {finished && (
        <CampaignFinishedCard
          campaign={jackpotCampaign.campaign}
          title={t("jackpot.campaignFinished")}
        />
      )}
      <CampaignJoinState campaign={jackpotCampaign.campaign} joined={joined} />
      <JackpotBoard jackpotCampaign={jackpotCampaign} />
      <div className={finished ? FINISHED_DIM : undefined}>
        <JackpotLatestWinsCard
          jackpotCampaign={jackpotCampaign}
          density="dock"
        />
      </div>
    </CampaignDockPanel>
  );
};
